import React, { useState } from 'react';
import { FileText } from 'lucide-react';

const BookProduct = ({ title, author, description, price, imageUrl, pdfSample, stripeLink }) => {
  const [loading, setLoading] = useState(false);

  const openPDFSample = () => {
    window.open(pdfSample, '_blank');
  };

  const handlePurchase = () => {
    if (stripeLink) {
      setLoading(true);
      window.location.href = stripeLink;
    } else {
      alert('Payment link not configured. Please add a Stripe payment link for this product.');
    }
  };

  return (
    <div className="product-card book-card">
      <div className="product-image-container">
        <img src={imageUrl} alt={title} className="product-image" />
        <div className="product-overlay">
          <button 
            className="sample-btn"
            onClick={openPDFSample}
          >
            <FileText size={20} />
            Read Sample
          </button>
        </div>
      </div>
      <div className="product-content">
        <h3 className="product-title">{title}</h3>
        <p className="product-author">{author}</p>
        <p className="product-description">{description}</p>
        <div className="product-footer">
          <span className="product-price">${price}</span>
          <button 
            onClick={handlePurchase}
            disabled={loading}
            className="buy-btn"
          >
            {loading ? 'Loading...' : 'Buy Now'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BookProduct;